import { FC, InputHTMLAttributes } from 'react'

import { TextField } from '@joor/design-system'
import { useField } from 'formik'

import { BaseProps } from './Field'

export type PropsType = BaseProps & InputHTMLAttributes<HTMLInputElement>

const Input: FC<PropsType> = ({ required, ...props }) => {
  const [
    { onChange: _fieldOnChange, onBlur: _fieldOnBlur, ...field },
    meta,
    { setValue, setTouched },
  ] = useField({
    disabled: props.disabled,
    name: props.name,
  })
  const shouldShowError = meta.touched && !!meta.error

  return (
    <TextField
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target?.value)
      }}
      onBlur={() => setTouched(true)}
      isRequired={required}
      {...(props?.readOnly && { defaultValue: field.value })}
      {...(shouldShowError && { errorMessage: meta.error })}
      {...field}
      {...props}
    />
  )
}

export default Input
